import { useContext } from 'react';
import { PriceSetContext } from '../../contexts/price/priceSetContext';

export default function usePriceSet() {
  return useContext(PriceSetContext);
}
